<template>
  <div class="text-center bg-white">
    <div class="component-header">
      <h1 class="q-mx-md" :style="{'font-size': $q.screen.lt.md ? '3.75rem' : '4.5rem'}">
        The Most Powerful <span class="text-secondary">EHR</span><br> for Education &amp; Simulation
      </h1>
      <p class="paragraph">
        Designed for Real-Time Simulation, Nursing,<br> Allied Health, Medical Assisting, and more.
      </p>
      <div class="q-my-md">
      <a href="#pricing" class="text-accent paragraph" @click.prevent="scrollToPricing"><q-icon
                    name="rocket_launch"
                    aria-hidden="true"
                  />&nbsp;Starts from $15 / Student</a>
        </div>
    </div>
    <div class="button-container q-mb-lg">
      <q-btn class="start-free-trial bg-accent text-white text-bold" label="Free Instructor Demo" to="/demo"/>
      <q-btn
        class="watch-demo text-primary text-bold"
        label="Take a Quick Tour"
        icon="play_circle_outline"
        to="/tour"
      />
    </div>
    <!--<div class="icon-container">
      <q-icon v-for="n in 4" :key="n" name="star" />
      <q-icon name="star_half" />
      <p>5,000+ success stories</p>
    </div>-->
    <div class="dashboad-container">
      <q-img src="/assets/homePage/chartflow-most-powerful-educational-ehr.png" class="dashboard-image" alt="ChartFlow EHR dashboard showing patient charts and medical records interface" />
      <div class="fade-overlay"></div>
    </div>
    <!--<div class="logo-container">
      <div class="logo"><q-img src="/assets/image 10.png" /></div>
      <div class="logo"><q-img src="/assets/image 15.png" /></div>
      <div class="logo"><q-img src="/assets/image 16.png" /></div>
      <div class="logo"><q-img src="/assets/image 10.png" /></div>
      <div class="logo"><q-img src="/assets/image 17.png" /></div>
    </div>-->
  </div>
</template>

<script setup>
defineOptions({
  name: "BannerComponent",
});

function scrollToPricing() {
  const target = document.getElementById('pricing')
  if (target) {
    target.scrollIntoView({ behavior: 'smooth' })
    target.setAttribute('tabindex', '-1')
    target.focus()
  }
}
</script>
<style scoped lang="scss">
.button-container {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.start-free-trial {
  border-radius: 30px;
  padding: 8px 6px;
  min-width: 180px;
  min-height: 45px;
}
.watch-demo {
  border: 1px solid $primary;
  border-radius: 30px;
  padding: 8px 6px;
  min-width: 180px;
  min-height: 45px;
}
.icon-container {
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  color: #f5c308;
}
.icon-container p {
  color: black;
  padding-top: 15px;
  padding-left: 15px;
}
.dashboad-container {
  position: relative;
  display: flex;
  width: 80vw;
  justify-content: center;
  margin: 0 auto;
  background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.2));
}
.dashboard-image {
  box-shadow: 0px 10px 15px #e5eefb;
  border: 5px solid #e5eefb;
  border-radius: 20px;
  display: block;
  margin: 0 auto;
  max-width: 100%;
}

.fade-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30%; /* Adjust height for the fade effect */
  background: linear-gradient(
    to bottom,
    transparent,
    rgba(255, 255, 255, 1) /* Fade to white */
  );
  pointer-events: none; /* Ensure the gradient overlay does not block interactions */
}
.logo-container {
  display: flex;
  justify-content: center;
  gap: 8rem;
  border-top: 1px solid #e7e7ea; /* Top border */
  border-bottom: 1px solid #e7e7ea; /* Bottom border */
  padding: 5px 0;
  width: 100vw;
}
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: auto;
  padding: 0 15px;
}

.path-image {
  position: absolute;
  left: 0;
  width: 150px;
}
</style>
